const processNode = (node: Node): Node => {
  const newNode = document.createElement('div');

  // Check if the node is an img node
  if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'IMG') {
    return document.createTextNode(`image: ${(node as HTMLImageElement).src}`);
  }

  if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
    // If node is an element with children, recursively process each child
    for (let i = 0; i < node.childNodes.length; i++) {
      newNode.appendChild(processNode(node.childNodes[i]));
    }

    return document.createTextNode(newNode.textContent || '');
  }

  // If it is a text node or an element without children, directly return its text content
  return document.createTextNode(node.textContent || '');
};

const generateContentWithFragment = (documentFragment: DocumentFragment) => {
  const div = document.createElement('div');

  div.appendChild(documentFragment);

  const content = div.innerHTML;

  if (content.length == 0) {
    return undefined;
  }

  return content;
};

/**
 * 获得选中的内容
 * @param selectionRange 选中的内容
 * @returns
 */
export const SelectionContent = (selectionRange: Range): string | undefined => {
  const documentFragment = selectionRange.cloneContents();

  const newFragment = document.createDocumentFragment();

  for (let i = 0; i < documentFragment.childNodes.length; i++) {
    newFragment.appendChild(processNode(documentFragment.childNodes[i]));
  }

  return generateContentWithFragment(newFragment);
};

/**
 * 获得选中的节点的内容
 * @param node 获得选中的节点
 * @returns
 */
export const NodeContent = (node: Node): string | undefined => {
  const newFragment = document.createDocumentFragment();

  for (let i = 0; i < node.childNodes.length; i++) {
    newFragment.appendChild(processNode(node.childNodes[i]));
  }

  return generateContentWithFragment(newFragment);
};

export const findImgNode = (node: Node): HTMLImageElement | undefined => {
  if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'IMG') {
    return node as HTMLImageElement;
  }

  if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
    // If node is an element with children, recursively process each child
    for (let i = 0; i < node.childNodes.length; i++) {
      const imgNode = findImgNode(node.childNodes[i]);

      if (imgNode) {
        return imgNode;
      }
    }
  }

  return undefined;
};

export const findParentTypeNode = (data: {
  fromNode: HTMLElement;
  targetType: string[];
  endNode?: HTMLElement;
  ignoreClass?: string[];
}): HTMLElement | undefined => {
  const { fromNode, targetType, endNode, ignoreClass } = data;

  const fromNodeWasIgnore = ignoreClass?.some((className) =>
    fromNode.classList.contains(className)
  );

  if (
    fromNode.nodeType === Node.ELEMENT_NODE &&
    targetType.includes(fromNode.nodeName.toLocaleLowerCase()) &&
    !fromNodeWasIgnore
  ) {
    return fromNode;
  }

  const parentNode = fromNode.parentNode;

  if (endNode && parentNode === endNode) {
    return undefined;
  }

  if (parentNode) {
    return findParentTypeNode({ fromNode: parentNode as HTMLElement, targetType, endNode });
  }

  return undefined;
};

export const findParentTypeNodeWithClassName = (data: {
  fromNode: HTMLElement;
  className: string;
}): HTMLElement | undefined => {
  const { fromNode, className } = data;

  if (fromNode.nodeType === Node.ELEMENT_NODE && fromNode.classList.contains(className)) {
    return fromNode;
  }

  const parentNode = fromNode.parentNode;

  if (parentNode) {
    return findParentTypeNodeWithClassName({ fromNode: parentNode as HTMLElement, className });
  }

  return undefined;
};
